import { produce } from 'immer';

import * as Types from './types';
import { actionTypes } from './constants';

export const defaultState: Types.ILottoState = {
    isNeedToStart: false,
    isAppInitError: false,
    isAppInitialized: false,
    isAppInitializing: false,
    isRenderingStarted: false,
    isIntegrationScriptError: false,
    isIntegrationScriptFetched: false,
    isIntegrationScriptFetching: false
};

export const reducer = produce((draftState, action: Types.TLottoAction): Types.ILottoState | void => {
    switch (action.type) {
        case actionTypes.LOTTO_START: {
            Object.assign(draftState, {
                isNeedToStart: true
            });

            break;
        }

        case actionTypes.LOTTO_STOP: {
            Object.assign(draftState, {
                isNeedToStart: false,
                isRenderingStarted: false,
                isAppInitialized: false,
                isIntegrationScriptFetched: false
            });

            break;
        }

        case actionTypes.LOTTO_RENDER_START: {
            Object.assign(draftState, {
                isRenderingStarted: true
            });

            break;
        }

        case actionTypes.LOTTO_INTEGRATION_SCRIPT_FETCHING: {
            Object.assign(draftState, {
                isIntegrationScriptError: false,
                isIntegrationScriptFetched: false,
                isIntegrationScriptFetching: true
            });

            break;
        }

        case actionTypes.LOTTO_INTEGRATION_SCRIPT_FETCHED: {
            Object.assign(draftState, {
                isIntegrationScriptError: false,
                isIntegrationScriptFetched: true,
                isIntegrationScriptFetching: false
            });

            break;
        }

        case actionTypes.LOTTO_INTEGRATION_SCRIPT_ERROR: {
            Object.assign(draftState, {
                isIntegrationScriptError: true,
                isIntegrationScriptFetched: false,
                isIntegrationScriptFetching: false
            });

            break;
        }

        case actionTypes.LOTTO_INITIALIZED_UPDATE: {
            Object.assign(draftState, {
                isAppInitError: false,
                isAppInitializing: false,
                isAppInitialized: action.payload
            });

            break;
        }

        case actionTypes.LOTTO_INITIALIZING_UPDATE: {
            Object.assign(draftState, {
                isAppInitError: false,
                isAppInitialized: false,
                isAppInitializing: true
            });

            break;
        }

        case actionTypes.LOTTO_INITIALIZE_ERROR: {
            Object.assign(draftState, {
                isAppInitError: true,
                isAppInitialized: false,
                isAppInitializing: false
            });

            break;
        }

        default: {
            break;
        }
    }
}, defaultState);
